import { MemreContainer, MemreFlexBox, MemrePeopleList } from 'components/core';
import { MemreBubblePlot } from 'components/visualisations';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AreaHeading from '../learner-dashboard/visulisations/AreaHeading';
import LearnMore from '../learner-dashboard/visulisations/LearnMore';

const OVERLINE = {
  STUDENTS: 'Goal Progress',
  SETS: 'Goal Progress',
  COURSES: 'Course Progress',
};

interface GoalProgressProps {
  data: any[];
  isStudentsView: boolean;
  isCoursesView?: boolean;
}

export default function GoalProgress({ data, isStudentsView, isCoursesView = false }: GoalProgressProps) {
  const { t } = useTranslation();
  const history = useHistory();

  const distanceToGoal = data.map((d) => d.distanceToGoal);
  const mean = _.round(_.mean(distanceToGoal));

  const filteredData = data.filter((d) => d.distanceToGoal >= 0 && d.distanceToGoal < 100);
  const completedData = data.filter((d) => d.distanceToGoal >= 100);

  const heading = t(`${mean}% (${completedData.length} out of ${data.length} completed)`);
  const overline = t(isCoursesView ? OVERLINE.COURSES : isStudentsView ? OVERLINE.STUDENTS : OVERLINE.SETS);

  const handleClick = (courseId: number) => {
    history.push(`/nav/my-knowledge-bank/${courseId}`);
  };

  return (
    <MemreFlexBox direction="column" sx={{ flexGrow: 1 }}>
      <MemreFlexBox justify="space-between" align="center">
        <AreaHeading overline={overline} heading={heading} />
        <LearnMore title="More details" type="info" width={500}>
          <AreaHeading overline={overline} heading={heading} />
          <MemrePeopleList
            data={data}
            denomination="%"
            fields={['distanceToGoal']}
            fieldNames={['%']}
            topNumber={100}
          />
        </LearnMore>
      </MemreFlexBox>
      <MemreContainer sx={{ gap: 2, pr: '5px', justifyContent: 'space-between' }}>
        <MemreBubblePlot
          data={filteredData}
          mean={mean}
          topNumber={100}
          onDotClick={isCoursesView ? handleClick : undefined}
          ariaLabel={t('Goal progress chart')}
          ariaDescription={t(
            'Bubble chart plotting each item by distance to goal and current memory strength. Bubble size represents total study time.'
          )}
        />
      </MemreContainer>
    </MemreFlexBox>
  );
}
